import { IPLAUserOption } from "utils/interfaces/slp";
import { ContactProgress, SLPParticipation, SLPStatus } from "utils/enums/slp";

export const getSLPStatusText = (status: SLPStatus) => {
  switch (status) {
    case SLPStatus.Pending:
      return "Pending";
    case SLPStatus.InProgress:
      return "In Progress";
    case SLPStatus.Completed:
      return "Completed";
    default:
      return "";
  }
};

export const getContactProgressText = (progress: ContactProgress) => {
  switch (progress) {
    case ContactProgress.NotStarted:
      return "Not Started";
    case ContactProgress.InProgress:
      return "In Progress";
    case ContactProgress.Assigned:
      return "Assigned";
    default:
      return "";
  }
};

export const getContactProgressClass = (status: ContactProgress) => {
  switch (status) {
    case ContactProgress.NotStarted:
      return "not-started";
    case ContactProgress.InProgress:
      return "in-progress";
    case ContactProgress.Assigned:
      return "assigned";
    default:
      return "default";
  }
};

export const getSLPStatusClass = (status: SLPStatus) => {
  switch (status) {
    case SLPStatus.Pending:
      return "pending";
    case SLPStatus.InProgress:
      return "in-progress";
    case SLPStatus.Completed:
      return "completed";
    default:
      return "default";
  }
};

export const getSLPParticipationText = (status?: SLPParticipation) => {
  switch (status) {
    case SLPParticipation.Active:
      return "Active";
    case SLPParticipation.NoFurtherSLPRequired:
      return "No Further SLP Required";
    default:
      return "";
  }
};

export const getSLPParticipationClass = (status?: SLPParticipation) => {
  switch (status) {
    case SLPParticipation.Active:
      return "active";
    case SLPParticipation.NoFurtherSLPRequired:
      return "color-gray";
    default:
      return "default";
  }
};

export const userRenderValue = (
  selected: Array<number>,
  userList: IPLAUserOption[]
) => {
  const selectedString: string[] = [];
  selected.forEach((item: number) => {
    const userInfo = userList?.find((user) => user.id === item);
    if (userInfo) {
      selectedString.push(userInfo.name);
    }
  });

  return selectedString.join(", ");
};
